import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const StateSpaceSearch = () => (
  <AIModuleSubtopic
    title="Introduction to Problem Solving by searching Methods-State Space search"
    videos={[
      "https://www.youtube.com/embed/By-uZDXVSC0",
      "https://www.youtube.com/embed/E5jVBqe59EE"
    ]}
    takeaways={[
      { text: "Understand the concept and structure of state space search in AI." },
      { text: "Learn how to represent and solve problems using state space search methods." }
    ]}
    questions={[
      {
        text: "Imagine you have three jugs measuring 12 gallons, 8 gallons, and 3 gallons and a water faucet. You can fill the jugs up or empty them out from one to another or onto the ground. How can you measure out exactly one gallon. Represent this as a problem in state space search and extract its production rules."
      },
      {
        text: "Formulate the problem definition for a board of size 3*3 with eight numbered tiles and a blank space. A tile adjacent to the blank space can slide into the space. The object is to reach a specified goal state, such as the one shown on the right of the figure.",
        image:"/ai_3.png"
      },
      {
        text: "Formulate the Towers of Hanoi problem with the given initial and goal states. The goal is to move all the disks to another peg, following these rules: i) Only one disk can be moved at a time. ii) A disk can only be moved to a peg that is empty or has a larger disk on top. Draw the complete state space tree for this scenario.",
        image:"/ai_4.png"
      }
    ]}
    exampleVideos={[]}
  />
);

export default StateSpaceSearch;
